'use client';
import East from '@mui/icons-material/East';
import { Box, Button, darken, Typography, useTheme } from '@mui/material';
import { Banner } from '@ui';
import Link from 'next/link';
import { Key } from 'react';
import { useTokens } from '../store/auth/useTokens';
import useBrokerConfig from '../store/useBrokerConfig';
import { useBrokerLearn } from '../store/useLearn';
import { useMixedPanel } from '../store/useMixPanel';
import { BrokerLearnBannerList } from '../types/master-data';

const HomePageBanner = () => {
  const { trackEvent } = useMixedPanel();
  const {
    data: brokerLearnData,
    isLoading: isBrokerConfigLoading,
    error: brokerLearnError,
  } = useBrokerLearn(
    useTokens.getState().userInfo?.broker?.toLowerCase(),
    'intraday',
    'FAQ'
  );

  const brokerConfig = useBrokerConfig();
  const theme = useTheme();

  const homepageBanners = brokerLearnData?.data?.broker_config?.sections?.find(
    (item: BrokerLearnBannerList) => item.type === 'homepage_banners'
  );

  const AboutIntradayBasketsButton = () => (
    <Link
      href="/learn"
      onClick={() => trackEvent('CLICK: About Intraday')}
      id="about-intraday-baskets-button"
    >
      <Button
        sx={{
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderRadius: '8px',
          background: `linear-gradient(90deg, ${
            theme.palette.primary.main
          } 0%, ${darken(theme.palette.primary.main, 0.3)} 100%)`,
          color: '#fff',
          textTransform: 'none',
          padding: '16px 16px',
          boxShadow: 'none',
        }}
        endIcon={<East sx={{ fontSize: 32, color: '#fff' }} />}
      >
        <Typography sx={{ fontWeight: 600 }}>
          About{' '}
          {brokerConfig.data?.broker_config?.brand_name || 'Intraday Baskets'}
        </Typography>
      </Button>
    </Link>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        justifyContent: 'center',
        width: { xs: '100%' },
      }}
    >
      <AboutIntradayBasketsButton />
      {homepageBanners?.items?.map(
        (
          item: { imageUrl: string; redirectUrl: string },
          index: Key | null | undefined
        ) => {
          return (
            <Box
              key={`homepage-banner-${index}`}
              p={0}
              width="100%"
              onClick={() => trackEvent('CLICK: About Intraday')}
            >
              <Banner imageUrl={item?.imageUrl} linkUrl={item?.redirectUrl} />
            </Box>
          );
        }
      )}
    </Box>
  );
};

export default HomePageBanner;
